
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileText, Download } from 'lucide-react';

interface CopyrightGuidesProps {
  onDownload: () => void;
}

const CopyrightGuides: React.FC<CopyrightGuidesProps> = ({ onDownload }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Copyright Registration Guide</CardTitle>
        <CardDescription>
          Step-by-step instructions for registering your musical works
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="rounded-lg border p-4">
            <h3 className="font-medium mb-2">U.S. Copyright Office Registration</h3>
            <p className="text-sm text-muted-foreground mb-2">
              Complete guide for registering your music with the U.S. Copyright Office
            </p>
            <Button size="sm" className="gap-2" onClick={onDownload}>
              <Download className="h-4 w-4" />
              <span>Download Guide</span>
            </Button>
          </div>
        
          <div className="rounded-lg border p-4">
            <h3 className="font-medium mb-2">International Copyright Protection</h3>
            <p className="text-sm text-muted-foreground mb-2">
              Learn how to protect your music globally with this comprehensive guide
            </p>
            <Button size="sm" className="gap-2" onClick={onDownload}>
              <Download className="h-4 w-4" />
              <span>Download Guide</span>
            </Button>
          </div>
        
          <div className="rounded-lg border p-4">
            <h3 className="font-medium mb-2">Copyright Infringement</h3>
            <p className="text-sm text-muted-foreground mb-2">
              What to do if someone uses your music without permission
            </p>
            <Button size="sm" className="gap-2" onClick={onDownload}>
              <Download className="h-4 w-4" />
              <span>Download Guide</span>
            </Button>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button variant="outline" className="gap-2">
          <FileText className="h-4 w-4" />
          <span>Register New Work</span>
        </Button>
        <Button variant="default" className="gap-2">
          <Download className="h-4 w-4" />
          <span>Download All Guides</span>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default CopyrightGuides;
